// The customer's fair price against our BP (spec 20260811), shared by the
// Customer's fair price card and the item row so both say the same thing.

export const fmt = (n) => (n == null || n === '' || Number.isNaN(Number(n)))
    ? null
    : Number(n).toLocaleString('en-GB', { maximumFractionDigits: 2 });

// The gap vs our BP. Multiples read better than percentages once the customer
// is way off (a £5,000 ask on a £122 BP is "41× our BP", not "+3,998%").
export function gapBadge(theirsPounds, bp) {
    const t = Number(theirsPounds), b = Number(bp);
    if (!Number.isFinite(t) || !Number.isFinite(b) || b <= 0) return null;
    const ratio = t / b;
    const label = ratio >= 2
        ? `${Math.round(ratio)}× our BP`
        : `${ratio >= 1 ? '+' : '−'}${Math.abs(Math.round((ratio - 1) * 100))}% vs BP`;
    const tone = ratio <= 1.1 ? 'ok' : (ratio <= 1.5 ? 'mid' : 'far');
    return { label, tone };
}
